import { defaultWagmiConfig } from "@web3modal/wagmi";
import { defineChain } from "viem";
import { avalanche, mainnet, base, polygon, arbitrum, mint, fireChain, hela, sonic, bscTestnet, } from "wagmi/chains";

  const projectId = "5f6c18132c6e21af2b276b34ad0af7ec";
  const metadata = {
    name: "Web3Modal",
    description: "Web3Modal",
    url: "https://web3modal.com",
    icons: ["https://avatars.githubusercontent.com/u/37784886"],
  };

  // @ts-ignore
  const bsc = defineChain({
    id: 56,
    name: "BNB Smart Chain",
    nativeCurrency: {
      decimals: 18,
      name: "BNB",
      symbol: "BNB",
    },
    rpcUrls: {
      default: { http: ["https://bsc-dataseed.bnbchain.org"] },
    },
    blockExplorers: {
      default: {
        name: "BscScan",
        url: "https://bscscan.com",
        apiUrl: "https://api.bscscan.com/api",
      },
    },
    contracts: {
      multicall3: {
        address: "0xca11bde05977b3631167028862be2a173976ca11",
        blockCreated: 15921452,
      },
    },
  });
  
  export const supportEVMChains = [
    bsc,
    mainnet,
    avalanche,
    base,
    polygon,
    arbitrum,
    mint,
    fireChain,
    hela,
    sonic,
    bscTestnet,
  ] as const;
  
  export const wagmiConfig = defaultWagmiConfig({
    chains: supportEVMChains,
    projectId,
    metadata,
    enableInjected: false,
    enableWalletConnect: true,
    enableEIP6963: true,
    enableCoinbase: false,
  });